import { h, Component } from "preact";
import { connect } from "react-redux";
import ActionBar from "../../components/ActionBar";
import ActionButton from "../../components/ActionButton";
// the npm react-credit-card-input has errors with preact
import CardLogos from "../../components/CardLogos";
import Note from "../../components/Note";
import ZipMoney from "./ZipMoney";
import { css } from "emotion";
import { payClicked, pay } from "../../state/actions/orderActions";

import config from "../../config";

const nextStageButton = css({ height: "40px !important", minWidth: 150 });

class PaymentIframe extends Component {
  shouldComponentUpdate(nextProps) {
    const { authKey } = this.props;
    return authKey !== nextProps.authKey;
  }
  render({ authKey, paymentFormLoaded }) {
    const BPOINT_API_URL = config("BPOINT_API_URL");
    return (
      <iframe
        id="payment-iframe"
        src={`${BPOINT_API_URL}dvtokens/iframe/add/${authKey}`}
        frameborder="0"
        title="payment details"
        lang="en"
        height="180px"
        width="100%"
        overflow-y="hidden"
        overflow-x="hidden"
        onload={() => paymentFormLoaded()}
      />
    );
  }
}

class PaymentBPointWrapper extends Component {
  makeEventPayment = authKey => {
    const { event, order, orderId, slug, pay, payClicked } = this.props;
    const eventId = event.data._id;
    payClicked();
    setTimeout(() => {
      pay(slug, orderId, "bpoint", { authKey }, eventId);
    }, 1000);
  };

  makeGlobalPayment = authKey => {
    const { order, orderId, slug, pay, payClicked } = this.props;
    payClicked();
    setTimeout(() => {
      pay(slug, orderId, "bpoint", { authKey }, order.userId, true);
    }, 1000);
  };

  render() {
    const { isGlobal } = this.props;
    if (isGlobal) {
      return (
        <PaymentBPoint {...this.props} makePayment={this.makeGlobalPayment} />
      );
    } else {
      return (
        <PaymentBPoint {...this.props} makePayment={this.makeEventPayment} />
      );
    }
  }
}

class PaymentBPoint extends Component {
  constructor() {
    super();
    this.paymentFormLoaded = this.paymentFormLoaded.bind(this);
    this.state = {
      formLoaded: false
    };
  }

  paymentFormLoaded() {
    this.setState({ formLoaded: true });
  }

  render({ event, order, makePayment, isGlobal }) {
    const { formLoaded } = this.state;

    if (order.paymentRequest.error) {
      window.scrollTo(0, 0);
    }
    const error = order.paymentRequest.error;
    const loading = order.paymentRequest.loading;
    // get the latest payment auth key
    const authKey =
      order.data && order.data.paymentAuth
        ? order.data.paymentAuth[order.data.paymentAuth.length - 1]
        : null;
    const orderId = order.data ? order.data._id : null;
    return (
      <div>
        <p>
          All transactions are secure and encrypted. Payment information is
          never stored.
        </p>
        {!isGlobal && event.data.amexFee && event.data.amexFee > 0 ? (
          <Note>American Express Surcharge Fee {event.data.amexFee}% </Note>
        ) : null}
        {error ? <p class="text-error">{error}</p> : ""}
        {!formLoaded && !loading ? <div class="loading loading-lg" /> : ""}

        <div>
          <PaymentIframe
            authKey={authKey}
            paymentFormLoaded={this.paymentFormLoaded}
          />
          <ZipMoney />
          <ActionBar>
            <ActionButton
              onClick={() => makePayment(authKey)}
              disabled={
                order.waitingToPay ||
                order.paymentRequest.loading ||
                order.timeExpired
              }
              dataCY="paynow"
              loading={order.waitingToPay || order.paymentRequest.loading}
              classNames={nextStageButton}
            >
              Pay Now
            </ActionButton>
            <CardLogos event={event} isGlobal={isGlobal} />
          </ActionBar>
        </div>
      </div>
    );
  }
}
export default connect(
  (state, ownProps) => ({
    event: state.event,
    order: state.order,
    giftCards: state.giftCards
  }),
  { payClicked, pay }
)(PaymentBPointWrapper);



// WEBPACK FOOTER //
// ./routes/payment/PaymentBPoint.js